<template>
    <v-card outlined flat>
        <v-virtual-scroll
                :items="sessions"
                :item-height="55"
                :height="height"
        >
            <template v-slot=" {item, index} ">
                <v-list-item @click="Select(item)"
                             class=" mt-1 px-0 "
                             :color="selected===item.sortkey?'indigo darken-4':''">
                    <v-list-item-action v-if="selected===item.sortkey" @click.stop="Watch(item)" class="my-0 mr-2">
                        <v-btn fab small depressed color="awesome" class="white--text" :loading="loading">
                            <v-icon>mdi-clipboard-outline</v-icon>
                        </v-btn>
                    </v-list-item-action>
                    <v-list-item-content class="py-0">
                        <v-container class="pa-0" style="position: relative;">
                            <div style="background-color: #0F2944;width:100%;height: 53px; overflow: hidden;"
                                 class="py-1">
                                <v-avatar v-for="(m,i) in item.meta" tile height="45" width="45" class="ml-1">
                                    <v-icon v-if="m==='text'" x-large class="white--text">mdi-comment-quote-outline
                                    </v-icon>
                                    <img v-else :src="m"/>
                                </v-avatar>
                            </div>
                            <div style="
                            position:absolute;
                            left:0;top:2px;
                            padding-left:5px;
                            padding-right:5px;
                            padding-bottom:2px;
                            color:white;
                            border-bottom-right-radius: 5px;
                            border-top-right-radius: 5px;
                            background-color: #0F2944AA;"><span class="font-weight-medium">{{item.name}}</span></div>
                        </v-container>
                    </v-list-item-content>
                    <v-list-item-action v-if="selected===item.sortkey && predelete!==item.sortkey" class="my-0">
                        <v-btn icon @click.stop="confirmDelete(item)">
                            <v-icon color="awesome" large>mdi-close-octagon-outline</v-icon>
                        </v-btn>

                    </v-list-item-action>
                    <v-list-item-action v-if="predelete===item.sortkey" @click.stop="Delete(item,index)"
                                        class="ml-2 my-0 mr-1">
                        <div style="border: solid thin #FF5252;border-radius: 3px; ">
                            <v-btn color="error" :loading="deleting" icon>
                                <v-icon>{{icons.warning}}</v-icon>
                            </v-btn>
                            <v-list-item-action-text class="error--text pr-2">Delete</v-list-item-action-text>
                        </div>
                    </v-list-item-action>
                </v-list-item>
            </template>

        </v-virtual-scroll>

    </v-card>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'

  export default {
    name: "Sessions",
    props: ['height'],
    components: {},
    data() {
      return {
        selected: false,
        loading: false,
        predelete: false,
        deleting: false,
        clnt: undefined,
      }
    },
    computed: {
      ...mapState(['icons', 'clipboarddialog', 'sessions'])
    },
    watch: {
      clipboarddialog(n, o) {
        if (!n) this.getAll()
      }
    },
    mounted() {
      this.clnt = document.getElementById('client')
      this.getAll()
    },
    methods: {
      ...mapActions(['get', 'post', 'delete']),
      ...mapMutations(['setClipBoard', 'setSessions']),
      async getAll() {
        this.setSessions(await this.get({path: 'api/notes/sessions'}))
      },
      async Select(d) {
        this.loading = false
        if (this.selected === d.sortkey) {
          this.selected = false
          this.predelete = false
        } else {
          this.selected = d.sortkey
          this.predelete = false
        }
      },
      async Watch(d) {
        if (this.selected === d.sortkey) {
          this.loading = true
          let session = await this.get({path: 'api/notes/getsession/' + d.partkey + '/' + d.sortkey})
          this.selected = false
          this.loading = false
          this.setClipBoard(session)
        } else {
          this.selected = d.sortkey
        }
      },
      async confirmDelete(d) {
        this.predelete = d.sortkey
      },
      async Delete(d, i) {
        this.deleting = true
        let dl = await this.delete({path: 'api/notes/deletesession/' + d.partkey + '/' + d.sortkey})
        this.deleting = false
        console.log(dl)
        this.sessions.splice(i, 1)
      }
    }
  }

</script>


<style scoped>
    .deletebtn {
        border: #FF5252
    }

    .deletebtn :hover {
        background-color: #FF5252AA;
    }
</style>
